import React from 'react';
import { BaasicInput } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

const BulkPrintHistoryCreateTemplate = ({ bulkPrintHistoryViewStore: { form, modalParams }, t }) => {
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.BULKPRINT.CREATE')}</h3>
				</div>
				<div className="ReactModal__body">
					<BaasicInput
						autoFocus
						field={form.$('name')}
						disabled={modalParams.data.numberOfFulfillmentOrders === 0}
					/>
					{form.error != null && <p className="type--color--warning spc--bottom--sml">{t(form.error)}</p>}
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--bottom--sml"
						type="submit"
						disabled={
							modalParams.data.numberOfFulfillmentOrders === 0 || form.submitting
						}
					>
						{t('SAVE')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(BulkPrintHistoryCreateTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/BulkPrintHistoryCreateTemplate.jsx